import { InitiateMandate } from '../entities';
import InitiateMandateResponseDTO, { InitiateMandateResponseBody } from '../entities/InitiateMandateResponseDTO';

const InitiateMandateResponseDTOtoInitiateMandateAdapter = (
  response: InitiateMandateResponseDTO,
): InitiateMandateResponseBody => {
  if (!response.body) {
    throw Error();
  }
  const initiateAuthorizationMandate = response.body;

  return new InitiateMandate(
    initiateAuthorizationMandate.authorizationId,
    initiateAuthorizationMandate.requestId,
    initiateAuthorizationMandate.authenticationMethod,
    initiateAuthorizationMandate.authorizationDurationSeconds,
    initiateAuthorizationMandate.authorizationExpiresAt,
  );
};

export { InitiateMandateResponseDTOtoInitiateMandateAdapter };
